var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"empty-box"},[_c('div',{staticClass:"img-box"},[(!_vm.isSearch)?_c('img',{attrs:{"src":require("../../assets/table_empty.png"),"alt":""}}):_c('img',{attrs:{"src":require("../../assets/search_table_empty.png")}}),_c('p',[_vm._v(_vm._s(!_vm.isSearch ? '这里空空如也~' : 'Sorry，木有找到您搜索的内容哦~'))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }